export const initialData = {
  nome: '',
  ordem: undefined
}
export default initialData;
